import React, {useContext} from "react";
import BatchShipments from "../BatchShipments/BatchShipments";
import {SocketContext} from "../../../contexts/SocketContext";
import UiContext from "../../../contexts/UiContext";
import UserContext from "../../../contexts/UserContext";
import SupplierContext from "../../../contexts/SupplierContext";

type Props = {};

export const BatchShipmentsWrapper = (props: Props) => {
    const socket = useContext(SocketContext)!;
    const uiContext = useContext(UiContext);

    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);

    return <BatchShipments
        socket={socket}
        toggleSidebar={uiContext.toggleSidebar}
        setSidebarComponent={uiContext.setSidebarComponent}
        setActivityIndicator={uiContext.setActivityIndicator}
        notifyFn={uiContext.notifyFn}
        userModel={userModel}
        supplierModel={supplierModel}
    />;
};
